export default "__VITE_ASSET__c5350025__"